var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.doAction}},[_vm._v("do")]),_c('button',{on:{"click":_vm.touchOrder}},[_vm._v("TO")]),_vm._v(" "+_vm._s(_vm.orders.length)+" "),_c('ol',_vm._l((_vm.orders),function(order){return _c('li',{key:order},[_vm._v(_vm._s(order))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }